import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import PanesHeader from 'modules/core/components/PanesHeader'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import AddLeaveTypeModal from 'modules/timeoff/components/LeaveTypeSettings/Modals/AddLeaveTypeModal'

const LeaveTypesHeader = () => {
  const [showModal, setShowModal] = React.useState(false)

  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const onSuccess = (leaveTypeName: string) => {
    navigate(navigation.settings.timeoffPolicies.newLeaveType.path, {
      state: { leaveTypeName },
    })
  }

  return (
    <>
      <Box paddingBottom="s24">
        <PanesHeader
          illustration="document-edit"
          title={i18n.t('settings.leave_types.list.title')}
          description={i18n.t('settings.leave_types.list.description')}
        />
        <Button
          type="secondary"
          onClick={() => setShowModal(true)}
          extra={{ 'data-intercom-target': 'add-leave-type-button' }}
        >
          {i18n.t('settings.leave_types.list.add_button')}
        </Button>
      </Box>

      {showModal && <AddLeaveTypeModal onClose={() => setShowModal(false)} onSuccess={onSuccess} />}
    </>
  )
}

export default LeaveTypesHeader
